import { Inbox } from "lucide-react";

type IEmptyTableProps = {
  text?: string | React.ReactNode;
  className?: string;
};

export const EmptyTable = ({ text, className }: IEmptyTableProps) => {
  return (
    <div className={`flex flex-col min-w-max items-center justify-center gap-3 p-12 ${className ?? ""}`}>
      <Inbox className="h-10 w-10 text-gray-300" strokeWidth={1.5} />
      <p className="text-[#b3b3b3] text-sm font-light leading-5 text-center">
        {text || "Nenhum dado encontrado."}
      </p>
    </div>
  );
};